// type IntervalTimeField = 'dateCreated';
// type IntervalType = 'hour' | 'day';
// type IntervalValue = number;,

type RelativeInverval = {
	field: 'dateCreated';
	type: 'hour' | 'day';
	value: number;
	border: number;
};

export class FilterParams {
	source?: number = 0;
	userType?: string = 'all';
	userPaidType?: string = 'all';
	userCreatedDevice?: string = 'all';
	lang?: string = 'all';
	refererType?: string = 'first';
	refererFilterType?: string = 'simple';
	dateFilters?: string[] = ['datePaid', 'dateCreated', 'dateSiteCreated', 'dateTo'];

	dateFilter?: string = 'all';
	discountType?: string = 'all';
	domain?: string = '';
	end?: string = '';
	fbImportStatus?: string = 'all';
	isUserCharts?: boolean = false;
	limit?: number = 500;
	markType?: string = 'all';
	minWidgetSearchQueryLen?: number = 2;
	promocodeMark?: string = '';
	siteUrl?: string = '';
	skip?: number = 0;
	socType?: string = '';
	start?: string = '';
	type?: string = 'day';
	typeDate?: string = 'dateCreate';
	// userCurrency?: string = '';
	userCurrency?: string = 'all';

	refExtendedFilters?: RefExtendedParams[] = [];

	siteIds?: string[];

	dateFilterParams?: Object = {};
	countReReg?: boolean = false;
	processorType?: string = 'noCashless';
	paymentwallMethod?: string = 'all';
	currency?: string = 'all';
	paidType?: string = 'noUber';
	tariffVariant?: string = 'all';
	tariffId?: string = 'all';
	tariffMigrationFrom?: string = 'all';
	tariffMigrationTo?: string = 'all';
	uberSite?: string = 'all';
	isSeoUber?: string = '';
	user21billing?: string = '';
	user21billingStart?: number = 0;
	user21billingEnd?: number = 21;
	sitesFilter?: string = 'all';
	isPublished?: boolean = false;
	isNotPublished?: boolean = false;
	isNotCompleted?: boolean = false;
	withDomain?: boolean = false;
	excludeFreeZones?: boolean = false;
	withoutDomain?: boolean = false;
	hasProductCard?: boolean = false;
	isPaidType?: boolean = false;
	isFBconvertor?: boolean = false;
	isVKconvertor?: boolean = false;
	domainZone?: string = '';
	subject?: string = 'all';
	templateId?: string = 'all';
	templateName?: string = '';
	category?: string = 'all';
	categoryMembership?: string = 'in';
	realSubject?: string = '';
	serverAlias?: string = 'all';
	lastLogin?: string = '';

	// Судя по всему, merge не умеет копировать классы, надо заменить на clone в будущем
	addedWidget?: paramsGtLt = { gt: '', lt: '' };
	actionCount?: paramsGtLt = { gt: '', lt: '' };
	promoProgress?: paramsGtLt = { gt: '', lt: '' };
	sitesNumber?: paramsGtLt = { gt: '', lt: '' };

	userImportSource?: string = '';
	regFilter?: string = 'all';
	isConfirm?: boolean = false;
	isNotConfirm?: boolean = false;
	emailType?: string = '';
	email?: string = '';
	emailOther?: string = '';
	countForOther?: number = 1;
	templateTagBorder?: number = 50;
	noticeName?: string = 'all';
	isShowRegDayTotal?: boolean = false;
	isShowReReg?: boolean = false;
	isShowBillingAdd?: boolean = false;
	isShowBillingPeriod?: boolean = false;
	isShowSourceChange?: boolean = false;
	isShowRelativeChange?: boolean = false;
	location?: string = '';
	isShowCountry?: boolean = false;
	experimentName?: string = '';
	experimentValue?: string = '';
	isFreemiunUser?: string = '';
	isFreemiun2User?: string = '';
	amountSplit?: string = '';
	regPath?: string = '';
	registrationSection?: string = '';
	tariffPageSplit?: string = '';
	isConvert?: string = '';
	flashPromo?: string = '';
	showNewTariffPage?: string = '';
	useReducedVariants?: string = '';
	randomFreemiun?: string = '';
	showTariffSelectionPage?: string = '';
	freemiumAndPremium?: string = '';
	summer2017?: string = '';
	newMainPage?: string = '';
	siteImportSplit?: string = '';
	newConverterSplit?: string = '';
	newMainPage2?: string = '';
	userDomainSplit?: string = '';
	greatLoginTime?: string = 'all';
	isBillingAllow?: boolean = false;
	usdAmountType?: string = 'historical';

	refGroup?: string = 'all';
	refSource?: string = 'all';
	refUrl?: string = '';

	dateTime?: string;
	reportType?: string;
	paginationDate?: string;
	groupDate?: string;
	inGroup?: string;
	page?: number = 1;
	period?: string = 'day';

	accessorDateFilter? = { type: null, start: null, end: null };

	isBilling?: boolean = false;
	isRegDay?: boolean = false;
	isDomainBilling?: boolean = false;
	isTemplateTag?: boolean = false;
	isExpiredPaid?: boolean = false;
	isExpiredDomains?: boolean = false;
	isNotice?: boolean = false;
	isPromocode?: boolean = false;

	dateType?: string = 'dateCreated';
	showType?: string;

	isAccessor?: boolean = false;

	chartValue? : string;
	chartDateType?: string = '';
	// chartPeriod?: string = '30days';

	month?: string;
	widget?: string;
	totalCount?: number;

	clearData?(keys) {
		let fp = new FilterParams();
		for(let key of keys) {
			this[key] = fp[key];
		}
	}

	chartFormat?: string = 'c3angular';
	divide?: number = 10;
	currencyType?: string;
	invoicePaidType?: number;
	isCountRequest?: boolean = false;
	intervalOtherBorder?: number = 100;
	isShowExpiredPaidAddFields?: boolean = false;
	wizardSplit?: string = '';

	searchQuery?: string;
	serverZone?: string = '';
	categoryName?: string;

	summaryS?: string;
	summaryE?: string;

	countries?: string[] = [];

	cities?: string[] = [];

	fieldList?: string[] = [];

	paidStatus?: string = '';
	paidMode?: string = '';
	trialStart?: number = 1;
	trialEnd?: number = 14;

	// Исключить пользователей, у которых есть сайты, не соответствующие заданным условиям
	isExcludeUserAndSite?: boolean = false;

	// Поле статус обычно используется в отчётах с кастомной формой фильтрации.
	// Для задания фильтря по "статусу" некоторого значения (статус сайта, оплать, захода и т.п.)
	status?: string;
	excludeBot?: boolean = false;
	excludePaidWithFrod1?: boolean = false;
	excludeRefundFrod1?: boolean = false;
	excludeCountActionsFrod1?: boolean = false;
	excludeQuiz?: boolean = false;
	excludeSitebox?: boolean = false;
	tab?:string = 'main';
	invoiceNumber?: string | number;
	excludePublishFrod1?: boolean = false;
	ab12611?: boolean = false;
	mark?: string = '';
	ignoreDomain?: boolean = true;
	hasPaidWithPromocode?: boolean = false;
	excludeRereg?: boolean = false;
	excludeBanned?: boolean = false;
	excludeBlocked?: boolean = false;
	userRegType?: string = 'usersWithSite';
	year?: number;
	isPaidStatusTrialExpired?: boolean;

	// все расчёты идут от даты оплаты сайта. Ире нужно чтобы можно было считать от даты регистрации пользователя
	reportDateType?: string = 'datePaid';//dateCreated

	cardExpiry?: string;

	relativeInverval?: RelativeInverval;
	promopultPaidType?: string;


	constructor(opts: object = {}) {
		Object.keys(opts).forEach(k => this[k] = opts[k]);
	}


	// setDateFilter(dateType, start, end) {
	// 	this.dateFilterParams[dateType] = {
	// 		start, end
	// 	};
	//
	// 	return this;
	// }

	isShowExcluded?: boolean = false;

	reportGUID?: string;
	chartType?: string;

	subjectType?: string[] | string;
	isUserHasDashboadPhone?: boolean = false;
	isExcludeArbitrage?: boolean = false;
}

export class RefExtendedParams {
	condition?: string;
	refererType?: string;
	searchByMarkUtm?: string;
	searchByMarkRule?: string;
	refererSearchValue?: string;
	oneMonth?: string;
}

export class DateParams {
	start?: string;
	end?: string;
	type?: string;
}

export class paramsGtLt {
	gt?: string = '';
	lt?: string = '';
}

export class ExperimentMap {
	isFreemiunUser?: string[] = ['Freemiun', 'noFreemiun'];
	isFreemiun2User?: string[] = ['Freemiun', 'noFreemiun'];
	amountSplit?: string[] = ['7usd', '5usd'];
	regPath?: string[] = ['website'];
	registrationSection?: string[] = ['wizard'];
	tariffPageSplit?: string[] = ['new', 'old'];
	isConvert?: string[] = ['success convert', 'cancel convert', 'not_convert'];
	flashPromo?: string[] = ['yes', 'no'];
	showNewTariffPage?: string[] = ['new3', 'old1'];
	useReducedVariants?: string[] = ['useReducedVariants long', 'useReducedVariants short'];
	randomFreemiun?: string[] = ['yes'];
	showTariffSelectionPage: string[] = ['old', 'new'];
	freemiumAndPremium: string[] = ['freemium', 'premium'];
	summer2017: string[] = ['yes', 'no'];
	newMainPage: string[] = ['first_newman', 'first_oldman', 'not_main_other', 'repeated_newman', 'repeated_oldman', 'undefined_oldman'];
	siteImportSplit: string[] = ['fb-new', 'fb-old'];
	newConverterSplit: string[] = ['vk-new', 'alt-vk'];
	newMainPage2: string[] = ['split2_new',  'split2_old'];
	userDomainSplit: string[] = ['yes',  'no'];
	wizardSplit: string[] = ['early',  'neowizard', 'lightwizard'];
	ab12611: string[] = ['new',  'old'];
}
